import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-3b8af960"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "forget-right"
};
var _hoisted_2 = /*#__PURE__*/_createTextVNode(" 忘记账号或密码？ ");
var _hoisted_3 = /*#__PURE__*/_createTextVNode("登录");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_input = _resolveComponent("a-input");
  var _component_a_form_item = _resolveComponent("a-form-item");
  var _component_a_input_password = _resolveComponent("a-input-password");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_form = _resolveComponent("a-form");
  return _openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    rules: _ctx.formRules,
    model: _ctx.formState,
    "label-col": _ctx.labelCol,
    "wrapper-col": _ctx.wrapperCol
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_form_item, {
        label: "",
        name: "account",
        class: "item-account"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_input, {
            size: "large",
            maxlength: 20,
            value: _ctx.formState.account,
            "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.formState.account = $event;
            }),
            placeholder: _ctx.accountText || '请输入账号'
          }, null, 8, ["value", "placeholder"])];
        }),
        _: 1
      }), _createVNode(_component_a_form_item, {
        label: "",
        name: "password",
        class: "item-password"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_input_password, {
            size: "large",
            maxlength: 18,
            value: _ctx.formState.password,
            "onUpdate:value": _cache[1] || (_cache[1] = function ($event) {
              return _ctx.formState.password = $event;
            }),
            placeholder: _ctx.passwdText || '请输入密码'
          }, null, 8, ["value", "placeholder"]), _createElementVNode("div", _hoisted_1, [_ctx.extraForgetTips ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "link",
            onClick: _ctx.showGetAccountDialog
          }, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)])];
        }),
        _: 1
      }), _createVNode(_component_a_form_item, {
        label: "",
        class: "pdt"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_button, {
            size: "large",
            maxlength: 6,
            class: "item-button",
            type: "primary",
            shape: "round",
            block: "",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["rules", "model", "label-col", "wrapper-col"]);
}